// extracted by mini-css-extract-plugin
export var label = "_cl-5";
export var slideContainer = "_cl-0";
export var slider = "_cl-1";
export var sliderLg = "_cl-4";
export var sliderMd = "_cl-3";
export var sliderSm = "_cl-2";